// autogenerated by channel_search/generate.py -- do not edit
import { skybus_ws_unsubscribe_t } from "@skydio/lcm/types/skybus_websocket/skybus_ws_unsubscribe_t";
export { skybus_ws_unsubscribe_t };

export const SKYBUS_WS_UNSUBSCRIBE = {
  channel: "SKYBUS_WS_UNSUBSCRIBE",
  channelId: 10484,
  type: skybus_ws_unsubscribe_t
};
